module.exports = __webpack_public_path__ + "static/media/lognew.9c1d0f52.jpg";